import { usePersistedState } from '../../hooks/usePersistetState';

export type PreviewLayout = 'flow' | 'stacked';

export const PREVIEW_SIZE_MIN = 64;
export const PREVIEW_SIZE_MAX = 200;
export const PREVIEW_SIZE_DEFAULT = 110;

// View controls for the category page-previews panel, persisted to localStorage
// so a user's size / density / layout choice survives across sessions.
export function usePagePreviewControls() {
  const [size, setSize] = usePersistedState<number>('categoryView.previewSize', PREVIEW_SIZE_DEFAULT);
  const [compact, setCompact] = usePersistedState<boolean>('categoryView.previewCompact', false);
  const [tint, setTint] = usePersistedState<boolean>('categoryView.previewTint', true);
  const [layout, setLayout] = usePersistedState<PreviewLayout>('categoryView.previewLayout', 'flow');

  return { size, setSize, compact, setCompact, tint, setTint, layout, setLayout };
}

export type PagePreviewControlsState = ReturnType<typeof usePagePreviewControls>;
